import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import { OrgProvider } from "./OrgContext";
import "./i18n"; // Import i18n configuration

// Suppress benign ResizeObserver loop errors (Recharts, date pickers in modals, etc.).
const isResizeObserverNoise = (message) =>
  typeof message === "string" && message.includes("ResizeObserver loop");

const prevOnError = window.onerror;
window.onerror = function (message, source, lineno, colno, error) {
  if (isResizeObserverNoise(message)) return true;
  if (typeof prevOnError === "function") {
    return prevOnError.call(this, message, source, lineno, colno, error);
  }
  return false;
};

// CRA dev overlay listens on window "error" — stop propagation for the same benign case.
window.addEventListener(
  "error",
  (event) => {
    if (isResizeObserverNoise(event.message)) {
      event.stopImmediatePropagation();
    }
  },
  true
);

if (process.env.REACT_APP_ENVIRONMENT === "Trial") {
  console.log = console.warn = console.error = () => {};
}

const app = (
  <Provider store={store}>
    <OrgProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </OrgProvider>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
serviceWorker.unregister();
